const axios = require('axios');

// http://127.0.0.1:8000
// https://escapetask.com

 const escapeAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000',
    timeout:20000,
    headers: {
        post:{
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        common: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            
        }
    },
    withCredentials:true,
});

escapeAxios.interceptors.request.use(function (config){
    const token=localStorage.getItem('auth_Token');
    config.headers.Authorization = token ? `Bearer ${token}` : ``;
    return config;
})

export default escapeAxios
